import create from 'zustand'
import { hotspotTypes } from '../../hotspot-types'

export const useHotspotDebugger = create((set) => ({
  enabled: false,
  selectedHotspot: hotspotTypes[0],
  setSelectedHotspot: (state) => set({ selectedHotspot: state }),
  setEnabled: (state) => set({ enabled: state }),
}))
